import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container w-auto mx-auto pt-2 px-2" }
const _hoisted_2 = {
  key: 0,
  class: "md:flex py-5 justify-left items-center"
}
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 1,
  class: "container w-auto mx-auto pt-2"
}
const _hoisted_5 = { class: "my-5 md:my-10 flex flex-col gap-0" }
const _hoisted_6 = { class: "space-y-10" }
const _hoisted_7 = {
  key: 2,
  class: "sm:flex py-5 justify-end"
}
const _hoisted_8 = { class: "block float-right" }
const _hoisted_9 = {
  class: "pr-5",
  for: "PO_nummer"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "error" }

import { computed, onMounted, ref } from "vue";
import Nprogress from "nprogress";
import "nprogress/nprogress.css";
import Cards from "@/components/Cards.vue";
import { instrumentI } from "@/interfaces/interfaces";


export default /*@__PURE__*/_defineComponent({
  __name: 'KalibratieoproepPage',
  setup(__props) {

const search = ref("");
const session = ref({});
const error = ref("");
const config_url = ref("");
const customMessage = ref("");
const loading = ref(true);
const language = ref("nl");
const instrumenten = ref([] as Array<instrumentI>);
const verkooprelatieNaam = ref("");
const PO_nummer = ref("");
const submitting = ref(false);
const translations: { [key: string]: { [key: string]: string } } = {
  nl: {
    allesVervangen: "Alles vervangen",
    allesKalibreren: "Alles kalibreren",
    allesUitGebruik: "Alles uit gebruik",
    insturen: "Insturen",
    poNummer: "PO nummer (optioneel) ",
    search: "Zoeken...",
  },
  fr: {
    allesVervangen: "Tout remplacer",
    allesKalibreren: "Tout calibrer",
    allesUitGebruik: "Tout hors service",
    insturen: "Envoyer",
    poNummer: "Numéro de Commande (facultatif) ",
    search: "Rechercher...",
  },
  en: {
    allesVervangen: "Replace all",
    allesKalibreren: "Calibrate all",
    allesUitGebruik: "All no longer in use",
    insturen: "Submit",
    poNummer: "PO number (optional) ",
    search: "Search...",
  },
  de: {
    allesVervangen: "Alles ersetzen",
    allesKalibreren: "Alles kalibrieren",
    allesUitGebruik: "Alles außer Betrieb",
    insturen: "Einsenden",
    poNummer: "Bestellnummer (optional) ",
    search: "Suchen...",
  },
};

const toggleVervangen = () => {
  instrumenten.value = instrumenten.value.map((instrument: instrumentI) => {
    if (instrument.Vervangen_door.some((obj) => obj.id)) {
      instrument.Vervangen = true;
      instrument.Kalibreren = false;
      instrument.Niet_meer_in_gebruik = false;
    }
    return instrument;
  });
};

const setLanguage = (siteLanguage = "nl") => {
  language.value = siteLanguage;
};

const getTranslatedText = (key: string) => {
  return translations[language.value][key];
};

const toggleKalibreren = () => {
  instrumenten.value = instrumenten.value.map((instrument: instrumentI) => {
    instrument.Vervangen = false;
    instrument.Kalibreren = true;
    instrument.Niet_meer_in_gebruik = false;
    return instrument;
  });
};

const toggleUitGebruik = () => {
  instrumenten.value = instrumenten.value.map((instrument: instrumentI) => {
    instrument.Vervangen = false;
    instrument.Kalibreren = false;
    instrument.Niet_meer_in_gebruik = true;
    return instrument;
  });
};

const allesVervangen = computed(() => {
  return !instrumenten.value.some((instrument: instrumentI) => !instrument.Vervangen);
});

const allesKalibreren = computed(() => {
  return !instrumenten.value.some((instrument: instrumentI) => !instrument.Kalibreren);
});

const allesUitGebruik = computed(() => {
  return !instrumenten.value.some((instrument: instrumentI) => !instrument.Niet_meer_in_gebruik);
});

const update = (instrument: instrumentI, action: string, newValue = undefined) => {
  instrument.Error = false;
  error.value = "";
  switch (action) {
    case "vervangen":
      if (instrument.Vervangen_door.some((obj) => obj.id)) {
        instrument.Vervangen = !instrument.Vervangen;
        if (instrument.Vervangen) {
          instrument.Kalibreren = false;
          instrument.Niet_meer_in_gebruik = false;
        }
      }
      break;
    case "kalibreren":
      instrument.Kalibreren = !instrument.Kalibreren;
      if (instrument.Kalibreren) {
        instrument.Vervangen = false;
        instrument.Niet_meer_in_gebruik = false;
      }
      break;
    case "niet_meer_in_gebruik":
      instrument.Niet_meer_in_gebruik = !instrument.Niet_meer_in_gebruik;
      if (instrument.Niet_meer_in_gebruik) {
        instrument.Vervangen = false;
        instrument.Kalibreren = false;
      }
      break;
    case "selectedVervanging":
      instrument.selectedVervanging = newValue;
      break;
    case "changeBattery":
      instrument.changeBattery = newValue;
      break;
    default:
      break;
  }
};

const filteredInstrumenten = computed(() => {
  return instrumenten.value.filter(
    (instrument) =>
      (search.value === ""
        ? true
        : instrument.Serienummer.toLowerCase().indexOf(search.value.toLowerCase()) !== -1) ||
      (search.value === ""
        ? true
        : instrument.Instrumentnaam.toLowerCase().indexOf(search.value.toLowerCase()) !== -1)
  );
});

const init = () => {
  return new Promise<void>((resolve) => {
    const params = new URLSearchParams(window.location.search);
    if (!params.get("init_config")) {
      throw new Error("no parameter init_config provided in url");
    }

    config_url.value = params.get("init_config") || "";
    resolve();
  }).catch((err) => {
    error.value = err;
    if (err.json) {
      return err.json.then((json: { message: string }) => {
        error.value = json.message;
      });
    }

    return undefined;
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const appendJavascript = (data: any) => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = data.scriptUrl;

  document.head.appendChild(script);
};

const fetchData = () => {
  Nprogress.start();

  fetch(`${config_url.value}${window.location.search}`, {
    method: "get",
    headers: {
      "content-type": "application/json",
    },
  })
    .then((res) => {
      if (!res.ok) {
        const responseError = new Error(res.statusText);
        responseError.json = res.json();
        throw responseError;
      }
      return res.json();
    })
    .then((json) => {
      appendJavascript(json);
      setLanguage(json.Sitelanguage);
      if (json.message) {
        customMessage.value = json.message;
      } else {
        instrumenten.value = json.metadata.instrumenten;
        if (instrumenten.value.length > 0) {
          verkooprelatieNaam.value = instrumenten.value[0].Naam_verkooprelatie || "";
        }
      }
    })
    .catch((err) => {
      error.value = err;
      if (err.json) {
        return err.json.then((json: { message: string }) => {
          error.value = json.message;
        });
      }

      return undefined;
    })
    .finally(() => {
      Nprogress.done();
      loading.value = false;
    });
};

function validateBeforeSubmit() {
  if (instrumenten.value.some((obj) => obj.Vervangen && !obj.selectedVervanging)) {
    instrumenten.value.filter((obj) => {
      if (obj.Vervangen && !obj.selectedVervanging) {
        obj.Error = true;
      }

      return obj;
    });

    if (language.value === "fr") {
      error.value =
        "Lors des sélections avec Remplacer, une sélection 'Remplacer par' est obligatoire.";
    } else if (language.value === "en") {
      error.value = "When replacing, the 'Replaced by' selection is required.";
    } else if (language.value === "de") {
      error.value = "Bei Auswahl mit Vervangen ist eine 'Ersetzt durch' Auswahl erforderlich.";
    } else {
      error.value = "Bij selecties met Vervangen is een 'Vervangen door' selectie verplicht";
    }
  } else {
    submitData();
  }
}

const submitData = () => {
  if (submitting.value) return;
  submitting.value = true;
  Nprogress.start();

  const selectedInstrumenten = instrumenten.value
    .filter((i: instrumentI) => i.Kalibreren || i.Vervangen || i.Niet_meer_in_gebruik)
    .map((i: instrumentI) => ({
      Serienummer: i.Serienummer,
      Kalibreren: i.Kalibreren,
      Vervangen: i.Vervangen,
      Niet_meer_in_gebruik: i.Niet_meer_in_gebruik,
      selectedVervanging:
        i.Vervangen && i.selectedVervanging
          ? { id: i.selectedVervanging.id, type: i.selectedVervanging.type }
          : undefined,
      changeBattery: i.changeBattery,
    }));

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      instrumenten: selectedInstrumenten,
      po_nummer: PO_nummer.value,
      session: session.value,
    }),
  };

  fetch(`${config_url.value}${window.location.search}`, requestOptions)
    .then(async (response) => {
      const data = await response.json();

      if (!response.ok) {
        const responseError = (data && data.message) || response.status;
        return Promise.reject(responseError);
      }

      if (window.top) {
        window.top.location.href = data.redirectUrl;
      }
      return data;
    })
    .catch((err) => {
      error.value = err;
      submitting.value = false;
      Nprogress.done();
    });
};

onMounted(async () => {
  await init();
  if (!error.value) {
    await fetchData();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString(customMessage.value), 1),
      (!(customMessage.value || loading.value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              type: "search",
              class: "form-control relative mr-10 min-w-0 block px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded-l transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-tpsoc-blue focus:outline-none",
              placeholder: translations[language.value].search
            }, null, 8, _hoisted_3), [
              [_vModelText, search.value]
            ]),
            _createElementVNode("button", {
              onClick: toggleVervangen,
              class: _normalizeClass(["text-white text-xs font-semibold mr-2 px-2.5 py-0.5 rounded bg-black", { 'bg-gullimex-orange': allesVervangen.value }])
            }, _toDisplayString(getTranslatedText("allesVervangen")), 3),
            _createElementVNode("button", {
              onClick: toggleKalibreren,
              class: _normalizeClass(["bg-black text-white text-xs font-semibold mr-2 px-2.5 py-0.5 rounded", { 'bg-gullimex-orange': allesKalibreren.value }])
            }, _toDisplayString(getTranslatedText("allesKalibreren")), 3),
            _createElementVNode("button", {
              onClick: toggleUitGebruik,
              class: _normalizeClass(["bg-black text-white text-xs font-semibold mr-2 px-2.5 py-0.5 rounded", { 'bg-gullimex-orange': allesUitGebruik.value }])
            }, _toDisplayString(getTranslatedText("allesUitGebruik")), 3)
          ]))
        : _createCommentVNode("", true),
      (!(customMessage.value || loading.value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("b", null, _toDisplayString(verkooprelatieNaam.value), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredInstrumenten.value, (instrument) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: instrument.Serienummer
                  }, [
                    (_openBlock(), _createBlock(Cards, {
                      instrument: instrument,
                      language: language.value,
                      key: instrument.Serienummer,
                      "onUpdate:vervangen": () => update(instrument, 'vervangen'),
                      "onUpdate:kalibreren": () => update(instrument, 'kalibreren'),
                      "onUpdate:Niet_meer_in_gebruik": () => update(instrument, 'niet_meer_in_gebruik'),
                      "onUpdate:selectedVervanging": 
                (newValue) => update(instrument, 'selectedVervanging', newValue)
              ,
                      "onUpdate:changeBattery": (newValue) => update(instrument, 'changeBattery', newValue)
                    }, null, 8, ["instrument", "language", "onUpdate:vervangen", "onUpdate:kalibreren", "onUpdate:Niet_meer_in_gebruik", "onUpdate:selectedVervanging", "onUpdate:changeBattery"]))
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!(customMessage.value || loading.value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(getTranslatedText("poNummer")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "PO_nummer",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((PO_nummer).value = $event)),
                class: "inline relative sm:mr-10 mr-0 min-w-0 block px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded-l transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-tpsoc-blue focus:outline-none"
              }, null, 512), [
                [_vModelText, PO_nummer.value]
              ])
            ]),
            _createElementVNode("button", {
              disabled: submitting.value,
              class: "bg-gullimex-orange hover:bg-blue-700 text-white font-bold py-2 px-4 rounded float-right sm:my-0 my-5 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-gullimex-orange",
              onClick: validateBeforeSubmit
            }, _toDisplayString(getTranslatedText("insturen")), 9, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, _toDisplayString(error.value), 1)
  ], 64))
}
}

})